<template>
  <b-modal title="Condições do Laudo Técnico" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-form-group label-cols="1" label="Operacional:" label-align="center">
            <b-form-textarea v-model="template.operacional" rows="8"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Condições Operacionais</b-alert>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-table bordered hover small :items="template.condicoes" :fields="fields.item_operacional"> </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="5">
          <b-form-group label="Descrição:" label-for="descricao" label-cols="2" label-align="right">
            <b-form-input id="descricao" v-model="condicao.descricao" />
          </b-form-group>
        </b-col>
        <b-col cols="5">
          <b-form-group label="Condição:" label-for="condicao" label-cols="2" label-align="right">
            <b-form-input id="condicao" v-model="condicao.condicao" />
          </b-form-group>
        </b-col>
        <b-col cols="1" class="pl-3 m-0">
          <b-button variant="primary" @click="addCondicao()">
            <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
        <b-col cols="1" class="pl-1 m-0">
          <b-button variant="warning" @click="delCondicao()">
            <b-icon icon="dash-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Riscos Envolvidos</b-alert>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-table bordered hover small :items="template.riscos" :fields="fields.item_risco"> </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10">
          <b-form-group label="Descrição:" label-for="descricao" label-cols="1" label-align="right">
            <b-form-input id="descricao" v-model="descricao" />
          </b-form-group>
        </b-col>
        <b-col cols="1" class="pl-3 m-0">
          <b-button variant="primary" @click="addRisco()">
            <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
        <b-col cols="1" class="pl-1 m-0">
          <b-button variant="warning" @click="delRisco()">
            <b-icon icon="dash-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import LaudoTecnico from "@/models_reports/LaudoTecnico";
import ReportFields from "@/tools/ReportFields";

export default {
  name: "ModalDeLaudoTecnicoCondicao",

  components: {},

  data() {
    return {
      show: false,
      template: new LaudoTecnico(),
      fields: new ReportFields(),
      condicao: { item: "", descricao: "", condicao: "" },
      descricao: "",
    };
  },

  methods: {
    addCondicao() {
      this.template.condicoes.push({
        item: this.template.condicoes.length + 1,
        descricao: this.condicao.descricao,
        condicao: this.condicao.condicao,
      });
    },

    delCondicao() {
      if (this.template.condicoes.length > 0) {
        this.template.condicoes.pop();
      }
    },

    addRisco() {
      this.template.riscos.push({ item: this.template.riscos.length + 1, descricao: this.descricao });
    },

    delRisco() {
      if (this.template.riscos.length > 0) {
        this.template.riscos.pop();
      }
    },

    call(laudo) {
      this.show = !this.show;
      this.template = laudo;
    },
  },

  setup() {
    const store = useSgcqStore();

    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped></style>
